import React from "react";


export default function TextCell({cell}){
	return (
		<>
			<div style={{...cell.column.style}}>{cell.value}</div>
		</>
	);
}